import styled from 'styled-components'

export const OverlayContainer = styled.div`
  background-color: rgba(0, 0, 0, 0.4);
  position: fixed;
  inset: 0;

  justify-content: center;
  align-items: center;
  z-index: 1000;

  > div {
    top: 50%;
    position: absolute;
    left: 50%;
    height: 40px;
    width: 40px;
    border-width: 6px;
  }
`
